// extracted by mini-css-extract-plugin
export default {"select":"select-module--select--2ffd4"};